/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Checkbox, Label } from 'semantic-ui-react';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import filterIcon from '../../images/components/contnets_header/filter icon.png';

class IssueHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isDisableStatus: false,
      checkValue: [],
      errSearch: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleAssignIssue = this.handleAssignIssue.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const {
      checkValue,
    } = this.state;
    const { filter } = this.props;
    const filterLength = filter.length;

    if (filter && prevProps.filter !== filter) {
      if (filterLength !== checkValue.length) {
        this.setState({
          checkValue: filter,
        });
      }
    }
  }

  componentWillUnmount() {
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            //isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                //isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      setTimeout(() => {
        this.setState({
          //isFocus: false,
        });
      }, 1500);
      this.props.onChangeSearch(event.target.value);
    }
  }

  handleFocus() {
    this.setState({
      //isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      //isFocus: false,
    });
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleAssignIssue() {
    this.props.handleAssignIssue();
  }

  handleChangeStatus() {
    this.props.handleChangeStatus();
  }

  onSubmit() {
    const { checkValue } = this.state;

    this.setState({
      visible: false,
    });

    this.props.onSubmit(
      { filter: checkValue, }
    );
  }

  changeStatusBtn = () => {
    const { t } = this.props;
    const { isDisableStatus } = this.state;
    if (isDisableStatus) {
      return (
        <a
          className="gray_button util_button"
          style={{
            pointerEvents: 'none',
            cursor: 'default',
            opacity: '.45',
          }}
        >
          {t('contents_header.menu.change_status')}
        </a>
      );
    }
    return (
      <a
        className="gray_button util_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleChangeStatus}
        onKeyUp={this.handleChangeStatus}
      >
        {t('contents_header.menu.change_status')}
      </a>
    );
  };

  clearSearch() {
    this.search.value = '';
    this.props.clearSearch();
  }

  closeMenu() {
    this.setState({
      visible: false,
    });
    this.props.closeMenu();
  }

  toggleMenu() {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
    });
  }

  render() {
    const {
      checkValue,
      errSearch,
    } = this.state;
    const { t } = this.props;

    return (
      <div className="contents_header">
        <div className="contents_header_inner">
          <h3 className="content_title">
            {t('my_page.title.assigned_issues')}
            <em>{this.props.currentCount}</em>
          </h3>
          <div className="util_wrap">
            <div className="util_item ">
              <div className="search_files_wrap">
                <img src={searchIcon} alt="" className="icon" />
                <input
                  type="search_files"
                  className="seach_text"
                  placeholder={t('contents_header.place_holder.uploaded_file')}
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onKeyPress={this.handleSearch}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                />
                <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {t('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
              </div>
            </div>
            <div
              className="util_item common_filter_toggle_button"
            >
              <a
                className="util_button icon_button"
                onClick={this.toggleMenu}
                onKeyUp={this.toggleMenu}
              >
                <img src={filterIcon} alt="" />
              </a>
              <div
                className={cx('common_filter', {
                  hide: !this.state.visible,
                })}
              >
                <div className="common_filter_header">
                  <h2>{t('contents_header.menu.filter_by')}</h2>
                </div>
                <Scrollbars
                  style={{ height: '310px' }}
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                >
                  <div className="common_filter_contents">
                    <div className="common_filter_contents_inner">
                      <div className="common_filter_item">
                        <p className="title">{t('contents_header.menu.security_risk_severity')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.critical')}
                                value="security_c"
                                checked={checkValue.indexOf('security_c') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.high')}
                                value="security_h"
                                checked={checkValue.indexOf('security_h') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.medium')}
                                value="security_m"
                                checked={checkValue.indexOf('security_m') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.low')}
                                value="security_l"
                                checked={checkValue.indexOf('security_l') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="common_filter_item">
                        <p className="title">{t('contents_header.menu.security_issue_status')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.undecided')}
                                value="status_sc_u"
                                checked={checkValue.indexOf('status_sc_u') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.resolved')}
                                value="status_sc_r"
                                checked={checkValue.indexOf('status_sc_r') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.disregarded')}
                                value="status_sc_d"
                                checked={checkValue.indexOf('status_sc_d') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="common_filter_item">
                        <p className="title">{t('contents_header.menu.license_family')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.protective')}
                                value="license_pt"
                                checked={checkValue.indexOf('license_pt') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.permissive')}
                                value="license_pm"
                                checked={checkValue.indexOf('license_pm') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.others')}
                                value="license_o"
                                checked={checkValue.indexOf('license_o') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="common_filter_item">
                        <p className="title">{t('contents_header.menu.license_issue_status')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.undecided')}
                                value="status_lc_u"
                                checked={checkValue.indexOf('status_lc_u') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.resolved')}
                                value="status_lc_r"
                                checked={checkValue.indexOf('status_lc_r') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.disregarded')}
                                value="status_lc_d"
                                checked={checkValue.indexOf('status_lc_d') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="common_filter_item">
                        <p className="title">{t('contents_header.menu.litigator')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.applicable')}
                                value="litigator_a"
                                checked={checkValue.indexOf('litigator_a') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="common_filter_item">
                        <p className="title">{t('contents_header.menu.litigator_issue_status')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.undecided')}
                                value="status_lt_u"
                                checked={checkValue.indexOf('status_lt_u') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.resolved')}
                                value="status_lt_r"
                                checked={checkValue.indexOf('status_lt_r') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={t('contents_header.menu.disregarded')}
                                value="status_lt_d"
                                checked={checkValue.indexOf('status_lt_d') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </Scrollbars>
                <div className="common_filter_footer">
                  <a className="cancel_button" onClick={this.closeMenu} onKeyUp={this.closeMenu}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="apply_button" onClick={this.onSubmit} onKeyUp={this.onSubmit}>
                    {t('modal.button.apply')}
                  </a>
                </div>
              </div>
            </div>
            <div className="button_wrap util_item">
              <a
                className="gray_button util_button assign_button"
                style={{ cursor: 'pointer' }}
                onClick={this.handleAssignIssue}
                onKeyUp={this.handleAssignIssue}
              >
                {t('contents_header.menu.assign_issue')}
              </a>
              {this.changeStatusBtn()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(IssueHeader);
